import React, { useEffect, useState } from "react";
import { fetchUsers, toggleUserActive } from "../services/api"; 
import { useNavigate } from "react-router-dom";

function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    const userRole = sessionStorage.getItem("userRole");
  const userProject = sessionStorage.getItem("project");
  const projectFilter = userRole !== "super_admin" ? userProject : null;
    try {
      setLoading(true);
      const response = await fetchUsers(projectFilter); 
      setUsers(response);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch users.");
      setLoading(false);
    }
  };

  const handleToggleActive = async (userId) => {
    try {
      await toggleUserActive(userId);
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user._id === userId ? { ...user, active: !user.active } : user
        )
      );
    } catch (err) {
      setError("Failed to update user status.");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>User List</h2>
      {error && <p style={styles.error}>{error}</p>}
      
      <button style={styles.addButton} onClick={() => navigate("/add-user")}>
        + Add User
      </button>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Role</th>
              <th style={styles.th}>Status</th>
               <th style={styles.th}>Project</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td style={styles.td}>{user.email}</td>
                <td style={styles.td}>{user.role}</td>
                
                <td style={styles.td}>{user.active ? "Active" : "Inactive"}</td>
                <td style={styles.td}>{user.project}</td>
                <td style={styles.td}>
                  <button
                    style={user.active ? styles.activeButton : styles.inactiveButton}
                    onClick={() => handleToggleActive(user._id)}
                  >
                    {user.active ? "Deactivate" : "Activate"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "20px",
    maxWidth: "600px",
    margin: "50px auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  title: {
    fontSize: "24px",
    marginBottom: "10px",
  },
  addButton: {
    padding: "10px",
    backgroundColor: "#28a745",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginBottom: "10px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "10px",
    borderBottom: "2px solid #ddd",
  },
  td: {
    padding: "10px",
    borderBottom: "1px solid #ddd",
  },
  activeButton: {
    backgroundColor: "green",
    color: "#fff",
    padding: "5px 10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  inactiveButton: {
    backgroundColor: "gray",
    color: "#fff",
    padding: "5px 10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  error: {
    color: "red",
  },
};

export default UserList;
